import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DetailSectionConfig } from "../Utilities";
import DetailField from "./DetailField";

interface SectionAccordionDetailsProps<T> {
  section: DetailSectionConfig<T>;
  details: T;
  defaultExpanded?: boolean;
}

export default function SectionAccordionDetails<T>({
  section,
  details,
  defaultExpanded = true,
}: SectionAccordionDetailsProps<T>) {
  return (
    <Accordion defaultExpanded={defaultExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${section.id}-content`}
        id={`${section.id}-header`}
        className="font-skyRegular text-xl"
      >
        {section.title}
      </AccordionSummary>
      <AccordionDetails>
        {section.fields.map((field) => (
          <DetailField
            key={field.id}
            field={field}
            value={details[field.key]}
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
}
